let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("30c70")).then(() => parcelRequire('lGaUC'));